import React, { Component } from 'react';
import {withRouter} from 'react-router-dom';
import withStyles from 'react-jss'
import {withContext} from '../../../custom/StateProvider';
import {API, BROKERID, TICKER_API} from "../../../../config";
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import {connect} from "react-redux";

import axios from "axios";
import BuySell from "./buy_sell";
import InvestorHoldings from "./investorHoldings";
import Button from "@material-ui/core/Button";

const balances = API.service('frozen-balance');

const styles = theme => ({
  tableRow:{
    borderWidth:'1px 0 1px 0',
    borderColor:'#e6e6e6',
    '&:nth-of-type(2n)':{
      backgroundColor:'#f6f6f6'
    },
    '& td':{
      padding:7,
    },
    '&:first-of-type':{
      borderTop:0,
    },
  },
  tableHead:{
    borderWidth:'1px 0 1px 0',
    borderColor:'#e6e6e6',
    backgroundColor:'#6e6e6e',
    color:'white'
  },
  accountDetails:{
    width:'300px',
    position:'absolute',
    display:'none',
    //border:'2px solid ' + theme.navigation.selected.backgroundColor,
    backgroundColor:'white',
    top:0,
    right:50,
    zIndex:1000,
  },
  bankDetails:{
    '&:hover .details_popup':{
      display:'block'
    }
  },
  debutton:{
    padding:'5px 12px',
    //background:theme.navigation.selected.backgroundColor,
    //color:theme.navigation.selected.contrast,
    borderRadius:3,
    boxShadow:'2px 2px 2px #eee',

    '&:hover':{
      //background:theme.navigation.hover.backgroundColor,
      //color:theme.navigation.selected.contrast,
    }
  },
  formControl:{
    width:'100%'
  }
});

class CompanySelection extends Component {
  state={
    quantity: 0,
    restricted_until:'2021-01-01',
    type:'FREE',
    company_account:'',
    comment:'',
    companies:false,
    holdings:[],
    instrument:false,
    remainder:0,
    selectedCompany:false,
    balances:false,
  };

  updateCompanyList(){
    const app = this;
    axios.get(TICKER_API + '/companies?$sort[symbol]=1&status[$not]=99&broker_exclusive[$in]=0&broker_exclusive[$in]='+BROKERID).then(x=>{
      app.setState({
        companies: x.data,
        selectedCompany: x.data[0],
      })
    });
  }

  getInvestorBalances(){
    const app = this;
    balances.get(this.props.investor._account).then(x=>{
      console.log('balances:',x);
      app.setState({
        balances:x.balance
      })
    })
  }

  componentDidMount() {
    this.updateCompanyList();
    this.getInvestorBalances();
  }

  handleChange = (event) => {
    this.setState({
      selectedCompany:this.state.companies[event.target.value],
      instrument:event.target.value
    })
  };

  close = () =>{
    this.props.context.update({
      popupContent: false,
    })
  };

  render() {
    const {classes} = this.props;

    return (
      <React.Fragment>
        <div style={{padding:10}}>
          <b>Investor:</b> {this.props.investor._firstname} {this.props.investor._surname}<br />
          <b>Account:</b> {this.props.investor._account}<br /><br />
          <br/>

          {(this.state.companies) &&
          <FormControl className={classes.formControl} style={{width: '100%'}}>
            <InputLabel htmlFor="currency">Instrument</InputLabel>
            <Select
              value={this.state.instrument}
              onChange={this.handleChange}
              inputProps={{
                name: 'instrument',
                id: 'instrument',
              }}
            >
              {

                this.state.companies.map((c,i) => {
                  if(c.status === '0') {
                    return (
                      <MenuItem value={i}>{c.symbol} - {c.name}</MenuItem>
                    )
                  } else {
                    return (
                      <React.Fragment/>
                    )
                  }
                })}
            </Select>
          </FormControl>
          }

          {(this.state.selectedCompany !== false && this.state.balances !== false) &&
            <div style={{position:'relative',marginTop:'10px'}}>
              <BuySell investor={this.props.investor} selectedCompany={this.state.selectedCompany} balances={this.state.balances} />
              <InvestorHoldings investor={this.props.investor} selectedCompany={this.state.selectedCompany} balances={this.state.balances} />
            </div>
          }
          <div style={{marginTop:15,textAlign:'right'}}>
            <Button variant="outlined" color="secondary" onClick={this.close}>
              Cancel
            </Button>
          </div>
        </div>
      </React.Fragment>
    )
  }
}

function mapStateToProps({auth})
{
  return {
    user: auth.user
  }
}

export default withContext(withStyles(styles,{withTheme:true})(withRouter(connect(mapStateToProps)(CompanySelection))));
